import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-folder-lock-open",
  "use": "icon-folder-lock-open-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-folder-lock-open\"><path d=\"M853.333333 256a85.333333 85.333333 0 0 1 85.333334 85.333333v426.666667a85.333333 85.333333 0 0 1-85.333334 85.333333H170.666667a85.333333 85.333333 0 0 1-85.333334-85.333333V256c0-47.36 37.973333-85.333333 85.333334-85.333333h256l85.333333 85.333333h341.333333m-42.666666 469.333333v-170.666666h-213.333334v-85.333334a42.666667 42.666667 0 0 1 42.666667-42.666666 42.666667 42.666667 0 0 1 42.666667 42.666666h85.333333a128 128 0 0 0-128-128 128 128 0 0 0-128 128v85.333334h-42.666667v170.666666h341.333334z\" fill=\"\" p-id=\"23137\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/folder-lock-open.svg
// module id = qLKq
// module chunks = 12